(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["estarta-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class EstartaHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.buttons = Array.from(this.querySelectorAll('[data-slide-button]'));
      this.current = 0;
      this.paused = false;
      this.delay = Number(this.dataset.autoplaySeconds || 7) * 1000;

      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1, true));
      this.buttons.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.slideButton), true)));
      this.querySelector('[data-pause]')?.addEventListener('click', (event) => this.togglePause(event.currentTarget));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());

      this.start();
    }

    show(index, userInitiated = false) {
      if (this.slides.length < 2) return;
      this.current = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === this.current;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (userInitiated) this.start();
    }

    start() {
      this.stop();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay !== 'true' || this.paused || reduceMotion || document.hidden || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.show(this.current + 1), this.delay);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
    }

    togglePause(button) {
      this.paused = !this.paused;
      button.setAttribute('aria-pressed', this.paused ? 'true' : 'false');
      const label = button.querySelector('[data-pause-label]');
      if (label) label.textContent = this.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      this.start();
    }
  }

  if (!customElements.get('estarta-hero-slider')) {
    customElements.define('estarta-hero-slider', EstartaHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
